export const highlightMatches = ({ str, highlightIndexes }) => {
    if (!highlightIndexes || !highlightIndexes.length) {
        return str;
    }

    return highlightIndexes.split(',').reduce((acc, value, index) => {
        const [start, end] = value.split('-');

        if (index === 0) {
            return `${acc} ${str.substring(0, start)}<b>${str.substring(start, end)}</b>`;
        }

        return `${acc} <b>${str.substring(start, end)}</b>`;
    }, '');
};
